import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AssetCategory } from '../state-man/models/asset-category.model';

@Injectable({
  providedIn: 'root'
})
export class AssetCategoryService {

  constructor(
    private apiService: ApiService
  ) { }
  
  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: AssetCategory[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('assets/categories/', version)
      return ret && { version: ret.version, rows: ret.rows && AssetCategory.buildMany(ret.rows) }
    } 
    catch (error) {      
      return null
    }
  }  
}
